<template>
  <b-row v-if="item">
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBItemList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col sm="4">
                  <p><b>{{$t('views.exsbitems.show.name')}}:</b> {{ item.name }}</p>
                  <p><b>{{$t('views.exsbitems.show.itemType')}}:</b> {{ item.itemType.name }}</p>
                  <p><b>{{$t('views.exsbitems.show.measure')}}:</b> {{ item.measure.name }}</p>
                  <p><b>{{$t('views.exsbitems.show.category')}}:</b> {{ item.category.name }}</p>
                </b-col>
                <b-col sm="4">
                  <p><b>{{$t('views.exsbitems.show.priceNetto')}}:</b> {{ item.priceNetto }}</p>
                  <p><b>{{$t('views.exsbitems.show.vatRate')}}:</b> {{ item.vatRate.range }}</p>
                  <p><b>{{$t('views.exsbitems.show.priceBrutto')}}:</b> {{ item.priceBrutto }}</p>
                  <p><b>{{$t('views.exsbitems.form.purchasePriceNetto')}}:</b> {{ item.purchasePriceNetto }}</p>
                  <p v-if="item.warningAvailability"><b>{{$t('views.exsbitems.form.warningAvailability')}}:</b> {{ item.warningAvailability }}</p>
                  <p v-if="item.minimumAvailability"><b>{{$t('views.exsbitems.form.minimumAvailability')}}:</b> {{ item.minimumAvailability }}</p>
                </b-col>
                <b-col sm="4">
                  <p v-if="item.height"><b>{{$t('views.exsbitems.form.height')}}:</b> {{ item.height }}</p>
                  <p v-if="item.width"><b>{{$t('views.exsbitems.form.width')}}:</b> {{ item.width }}</p>
                  <p v-if="item.weight"><b>{{$t('views.exsbitems.form.weight')}}:</b> {{ item.weight }}</p>
                  <p v-if="item.color"><b>{{$t('views.exsbitems.form.color')}}:</b> {{ item.color }}</p>
                  <p v-if="item.advantage"><b>{{$t('views.exsbitems.form.advantage')}}:</b> {{ item.advantage }}</p>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card v-if="warehousesStates.length > 0 && item">
            <h6 class="card-title">{{$t('views.exsbitems.show.warehouseStates')}} {{ item && item['title'] }}</h6>
            <hr class="mt-1 mb-0">
              <b-row>
                <b-col>
                  <table class="table table-sm border-table">
                    <tr>
                      <th></th>
                      <th>
                        {{$t('views.exsbitems.show.warehouseStatesTable.warehouse')}}
                      </th>
                      <th>
                        {{$t('views.exsbitems.show.warehouseStatesTable.quantity')}}
                      </th>
                    </tr>
                    <tr v-for="(warehousesState, index) in warehousesStates" v-bind:key="'warehousesState-' + index">
                      <td class="text-center">
                        <i v-if="warehousesState.item.minimumAvailability && warehousesState.quantity <= warehousesState.item.minimumAvailability" class="fa fa-circle fa-lg"
                           style="color: #dc3545;"
                           v-b-tooltip :title="$t('views.exsbitems.form.minimumAvailability') + ': ' + warehousesState.item.minimumAvailability"></i>
                        <i v-else-if="warehousesState.item.warningAvailability && warehousesState.quantity <= warehousesState.item.warningAvailability" class="fa fa-circle fa-lg"
                           style="color: #ffc107;"
                           v-b-tooltip :title="$t('views.exsbitems.form.warningAvailability') + ': ' + warehousesState.item.warningAvailability"></i>
                      </td>
                      <td>
                        <router-link v-if="warehousesState.warehouse['@id']" :to="{ name: 'EXSBWarehouseShow', params: { id: warehousesState.warehouse['@id'] }}">{{ warehousesState.warehouse.name }}</router-link>
                      </td>
                      <td>{{ warehousesState.quantity }}</td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
          </b-card>
          <b-card v-if="item.priceUserData.length > 0 && ableToViewPriceUserData">
            <span class="h6">
              {{$t('menu.exsbpriceuserdata.list')}}
            </span>
            <span v-if="ableToAddPriceUserData" class="float-right">
              <button type='button' @click="toggleCreateEXSBPriceUserDataModal()" class="btn btn-info btn-circle btn-sm mt-0 mb-2 ml-1 mr-2" v-b-tooltip.hover :title="$t('views.excmcase.create.title')">
                <i class="fa fa-plus"></i>
              </button>
            </span>
            <hr class="mt-2 mb-1">
            <List :item="item['@id']"></List>
          </b-card>
        </b-col>
        <b-col>
          <b-card v-if="warehousesStates.length > 0 && item">
            <h6 class="card-title">{{$t('views.exsbitems.show.documents')}} {{ item && item['title'] }}</h6>
            <hr class="mt-1 mb-0">
              <b-row>
                <b-col>
                  <table class="table table-sm border-table">
                    <tr>
                      <th>{{$t('views.exsbdocument.list.documentType')}}</th>
                      <th>{{$t('views.excmtask.list.table.task')}}</th>
                      <th>{{$t('views.exsbinvoices.show.title')}}</th>
                      <th>{{$t('views.exsbdocument.list.number')}}</th>
                      <th>{{$t('views.exsbdocument.list.dateOfIssue')}}</th>
                      <th></th>
                    </tr>
                    <tr
                      v-for="item in documents" :key="item['@id']">
                      <td>{{ item['documentType'].name }}</td>
                      <td v-if="item.task">{{ item.task.idTaskType.title }}</td>
                      <td v-else></td>
                      <td v-if="item.idInvoice">{{ item.idInvoice.number }}</td>
                      <td v-else></td>
                      <td>{{ item['number'] }}</td>
                      <td>{{ $moment(item['dateOfIssue']).format('YYYY-MM-DD') }}</td>
                      <td>
                        <router-link tag="button" :to="{name: 'EXSBDocumentShow', params: { id: item['@id'] }}" class="btn btn-link fa fa-search fa-lg" />
                      </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <ItemPictures :item="item" v-model="pictureUploaded"></ItemPictures>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import ApiService from '@/utils/ApiService'
import List from '@/components/Dashboard/Views/BusinessBundle/exsbpriceuserdata/List'
import ItemPictures from '@/components/Dashboard/Views/BusinessBundle/exsbitem/components/ItemPictures'

export default {
  components: {
    ItemPictures,
    List
  },

  computed: {
    ableToAddPriceUserData () {
      return checkPermission('warehouses', 'EXSBPriceUserDataCreate')
    },
    ableToViewPriceUserData () {
      return checkPermission('warehouses', 'EXSBPriceUserDataList')
    },
    ...mapGetters({
      deleteError: 'exsbitem/del/error',
      error: 'exsbitem/show/error',
      isLoading: 'exsbitem/show/isLoading',
      item: 'exsbitem/show/retrieved'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  data () {
    return {
      warehousesStates: [],
      documents: [],
      pictureUploaded: 0
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemShow')
  },

  watch: {
    item: function (newItem) {
      this.getWarehousesStates(this.getIdLink(newItem['@id']))
      this.channelBusinessWarehousesStates = this.$store.state.Pusher.subscribe('api/e_x_s_b_warehouse_items')
      this.channelBusinessWarehousesStates.bind('e_x_s_b_warehouse_items', data => {
        this.getWarehousesStates(this.getIdLink(newItem['@id']))
      })
      this.getItemDocuments(this.getIdLink(newItem['@id']))
      this.channelBusinessDocuments = this.$store.state.Pusher.subscribe('api/e_x_s_b_documents')
      this.channelBusinessDocuments.bind('e_x_s_b_warehouse_items', data => {
        this.getItemDocuments(this.getIdLink(newItem['@id']))
      })
    },
    pictureUploaded: function () {
      if (this.pictureUploaded === 1) {
        this.retrieve(decodeURIComponent(this.$route.params.id))
        this.pictureUploaded = 0
      }
    }
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_warehouse_items')
    this.$store.state.Pusher.unsubscribe('e_x_s_b_documents')
  },

  methods: {
    ...mapMutations({
      toggleCreateEXSBPriceUserDataModal: 'exsbpriceuserdata/createModal/toggleModal'
    }),
    ...mapActions({
      del: 'exsbitem/del/del',
      reset: 'exsbitem/show/reset',
      retrieve: 'exsbitem/show/retrieve'
    }),

    async getWarehousesStates (id) {
      const response = await new ApiService('e_x_s_b_warehouse_items?item=' + id).getResults()
      this.warehousesStates = response.items
    },
    async getItemDocuments (id) {
      const response = await new ApiService('e_x_s_b_items/' + id + '/documents').getResults()
      this.documents = response.items
    },
    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBItemList' }))
      }
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
